import React from 'react';
import { FlexColumn, Text } from 'core/components';
import Markdown from 'app/components/markdown/Markdown';
import { SmallHeading, SubAgentRequestBlock } from '../KaizenChatSession.styles';

// Each sub-agent defines its own input schema, so probe the usual suspects for the prompt.
const REQUEST_TEXT_KEYS = ['prompt', 'question', 'query', 'task', 'request', 'instruction', 'input'];

function getRequestTextKey(queryObject) {
  return REQUEST_TEXT_KEYS.find((k) => typeof queryObject[k] === 'string' && queryObject[k].trim());
}

const SubAgentRequest = ({ queryObject, title = 'Instructions' }) => {
  if (!queryObject || typeof queryObject !== 'object') {
    return null;
  }

  const textKey = getRequestTextKey(queryObject);

  // Sub-agents also accept optional context (test_ids, agent_ids, …) worth showing alongside.
  const extras = Object.entries(queryObject).filter(
    ([key, value]) => key !== textKey && value !== null && value !== undefined && value !== ''
  );

  if (!textKey && extras.length === 0) {
    return null;
  }

  return (
    <SubAgentRequestBlock>
      <SmallHeading>{title}</SmallHeading>
      {textKey && <Markdown>{queryObject[textKey]}</Markdown>}
      {extras.length > 0 && (
        <FlexColumn gap="2px">
          {extras.map(([key, value]) => (
            <Text key={key} small muted>
              {key}: {typeof value === 'object' ? JSON.stringify(value) : String(value)}
            </Text>
          ))}
        </FlexColumn>
      )}
    </SubAgentRequestBlock>
  );
};

export default SubAgentRequest;
